/* Mesmerize · Bracelet builder hero · mes-builder-hero.js (no dependencies) */
(function () {
  'use strict';
  var DESK = '(min-width: 1024px)';
  var CARDS = { w: [1, .3, 10, 1], e: [1.13, 2.1, 12, 1], wr: [.91, 4.2, 18, 1], m: [1.07, 5.7, 9, 1], mwr: [.93, 1.2, 0, .7], mm: [1.08, 3.6, 0, .7], ms: [.97, 5.1, 0, .5], ms2: [1.11, 2.7, 0, .5] };

  function init(root) {
    if (root.__mbh) return; root.__mbh = true;
    var data; try { data = JSON.parse(root.querySelector('[data-mbh-json]').textContent); } catch (e) { return; }
    var byId = {}; data.stones.forEach(function (s) { byId[s.id] = s; });
    var slots = []; for (var i = 0; i < 16; i++) slots.push(byId[data.initial[i]] ? data.initial[i] : null);
    var st = { clasp: data.clasp || 'gold', wrist: 16.5, cyc: 0 };
    var q = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var beads = q('[data-bead]'), counts = q('[data-count]'), wrists = q('[data-wrist]'), claspImgs = q('[data-clasp-img]'), claspNames = q('[data-clasp-name]'), sws = q('[data-clasp]');
    var reduce = matchMedia('(prefers-reduced-motion: reduce)');
    var desk = matchMedia(DESK);

    function render() {
      beads.forEach(function (b) {
        var id = slots[+b.getAttribute('data-bead')], s = id && byId[id], img = b.firstElementChild;
        var src = s ? s.src : data.empty; if (img.getAttribute('src') !== src) img.setAttribute('src', src);
        b.classList.toggle('is-empty', !s); b.disabled = !s;
        b.setAttribute('aria-label', s ? s.name + ', remove' : 'Empty slot');
      });
      var n = slots.filter(Boolean).length;
      counts.forEach(function (c) { c.textContent = n; });
      wrists.forEach(function (w) { w.textContent = st.wrist.toFixed(1) + ' cm'; });
      claspImgs.forEach(function (im) { if (im.getAttribute('src') !== data.clasps[st.clasp]) im.setAttribute('src', data.clasps[st.clasp]); });
      claspNames.forEach(function (c) { c.textContent = st.clasp.charAt(0).toUpperCase() + st.clasp.slice(1); });
      sws.forEach(function (s) { s.setAttribute('aria-pressed', s.getAttribute('data-clasp') === st.clasp ? 'true' : 'false'); });
    }
    /* V9.28.156 (Shrey, 5 Oct): "Build yours" opens the builder's EMPTY canvas, not the banner's demo bracelet. The link is
       the plain builder URL the section renders; the script no longer rewrites it with the build. */
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-add],[data-bead],[data-clasp],[data-wrist-step]'); if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-add')) {
        var i = slots.indexOf(null); if (i < 0) { st.cyc = (st.cyc + 1) % 16; i = st.cyc; }
        slots[i] = t.getAttribute('data-add');
      } else if (t.hasAttribute('data-bead')) { slots[+t.getAttribute('data-bead')] = null; }
      else if (t.hasAttribute('data-clasp')) { st.clasp = t.getAttribute('data-clasp'); }
      else { st.wrist = Math.max(14, Math.min(21, st.wrist + .5 * +t.getAttribute('data-wrist-step'))); }
      render();
    });

    function fit() {
      var w = root.clientWidth || innerWidth, s = Math.min(w / 390, 1);
      root.style.setProperty('--mbh-sd', w / 1440); root.style.setProperty('--mbh-sm', s); root.style.setProperty('--mbh-lm', ((w - 390 * s) / 2) + 'px');
    }
    fit();
    if (window.ResizeObserver) new ResizeObserver(fit).observe(root); else addEventListener('resize', fit);

    // motion: 30fps, only while on screen and tab visible, off for reduced motion
    var M = {}; q('[data-m]').forEach(function (el) { M[el.getAttribute('data-m')] = el; });
    var ptr = { x: 0, y: 0 }, sp = { x: 0, y: 0 }, visible = false, raf = 0, last = 0;
    var fine = matchMedia('(hover: hover) and (pointer: fine)');
    root.addEventListener('mousemove', function (e) { if (!fine.matches || !desk.matches) return; var r = root.getBoundingClientRect(); ptr.x = (e.clientX - r.left) / r.width * 2 - 1; ptr.y = (e.clientY - r.top) / r.height * 2 - 1; });
    root.addEventListener('mouseleave', function () { ptr.x = ptr.y = 0; });
    function n(t, f, p) { return Math.sin(t * f + p) * .62 + Math.sin(t * f * 2.31 + p * 1.9) * .38; }
    function set(k, v) { if (M[k]) M[k].style.transform = v; }
    function frame(t) {
      sp.x += (ptr.x - sp.x) * .08; sp.y += (ptr.y - sp.y) * .08;
      var d = desk.matches, keys = d ? ['w', 'e', 'wr', 'm'] : ['mwr', 'mm', 'ms', 'ms2'];
      keys.forEach(function (k) {
        var c = CARDS[k], s = c[0], p = c[1], dd = c[2], a = c[3];
        var x = n(t, .31 * s, p) * 4 * a + sp.x * dd, y = n(t, .43 * s, p + 2) * 7 * a + sp.y * dd * .6;
        var rx = n(t, .37 * s, p + 4) * 2.6 * a - sp.y * 3, ry = n(t, .29 * s, p + 6) * 3.2 * a + sp.x * 4, rz = n(t, .23 * s, p + 8) * .9 * a;
        set(k, 'translate(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px) perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) rotate(' + rz.toFixed(2) + 'deg)');
      });
      var bob = n(t, .4, 1);
      var ring = 'translate(' + (sp.x * -10).toFixed(2) + 'px,' + (bob * (d ? 10 : 6) + sp.y * -6).toFixed(2) + 'px) perspective(1400px) rotateX(' + (n(t, .27, 3) * 5 - sp.y * 4).toFixed(2) + 'deg) rotateY(' + (n(t, .22, 5) * 6 + sp.x * 6).toFixed(2) + 'deg) rotate(' + (n(t, .17, 7) * 2.5).toFixed(2) + 'deg)';
      if (d) {
        set('ring', ring);
        set('shadow', 'translateX(' + (sp.x * -6).toFixed(2) + 'px) scale(' + (1 - bob * .06).toFixed(3) + ')');
        set('gobo', 'translateX(' + (n(t, .05, 0) * 16).toFixed(2) + 'px)');
        set('beam', 'translateX(' + (n(t, .06, 2) * 30).toFixed(2) + 'px)');
      } else {
        set('mring', ring); set('mshadow', 'scale(' + (1 - bob * .06).toFixed(3) + ')');
      }
    }
    /* Motion runs on its own clock that stops while paused, so a pause (scroll, off-screen, hidden tab) resumes where it left
       off instead of jumping to where the wall clock says the cards should be. */
    var clk = 0, prev = 0;
    function loop(ts) { raf = 0; if (!running()) { prev = 0; return; } raf = requestAnimationFrame(loop); if (prev) clk += Math.min(ts - prev, 50); prev = ts; if (ts - last < 33) return; last = ts; frame(clk / 1000); }
    /* V9.28.153 (old-Android pass): the idle float pauses while the page scrolls and resumes 200ms after it stops, so weak
       phones never composite the six moving layers in the same frames as a scroll. Only the drift pauses; nothing jumps. */
    var scrolling = false, scrollT = 0;
    addEventListener('scroll', function () { scrolling = true; clearTimeout(scrollT); scrollT = setTimeout(function () { scrolling = false; kick(); }, 200); }, { passive: true });
    function running() { return visible && !scrolling && !document.hidden && !reduce.matches; }
    function kick() { if (running() && !raf) raf = requestAnimationFrame(loop); }
    if (window.IntersectionObserver) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; kick(); }, { rootMargin: '80px' }).observe(root); else { visible = true; kick(); }
    document.addEventListener('visibilitychange', kick);
    render();
  }

  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('.mbh'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
